import { connect } from "react-redux";
import { compose } from "recompose";
import { signUp } from "src/modules/auth/duck/epics";
import { withApp } from "src/components/App/Context";
import SignUp from "./SignUp";
import { getFamilyName } from "src/modules/auth/duck/selectors";

function mapStateToProps(state) {
  return {
    familyName: getFamilyName(state)
  };
}

function mapDispatchToProps(dispatch, { app }) {
  return {
    signUp: ({ familyName, email, password }) =>
      dispatch(signUp({ familyName, email, password, app }))
  };
}

const enhance = compose(withApp, connect(mapStateToProps, mapDispatchToProps));

export default enhance(SignUp);
